<template>
  <div id="app">
    <button id="goToTop" :style="{ bottom: goToTopBottom }" @click="goToTop()">
      <div class="arrow-down"></div>
    </button>
    <div>
      <div class="back-container">
        <router-link class="el-btn" to="/customer/consultation" @click.native="onConsultationCta">
          <div class="back-container__cta back-container__cta--application">
            <div class="back-container__cta-icon">
              <img src="@/assets/icons/icon-application-w.svg" width="65" alt="간편 상담신청 아이콘" />
            </div>
              <div class="back-container__cta-title">간편 상담신청</div>
              <div class="back-container__cta-sub-title">연락처 남기고 상담 신청하기</div>
          </div>
        </router-link>
        <router-link class="el-btn" to="/customer/store-locator">
          <div class="back-container__cta back-container__cta--find-store">
          <div class="back-container__cta-icon">
            <img src="@/assets/icons/icon-find-store-w.svg" width="65" alt="가까운 매장 찾기 아이콘" />
          </div>
          <div class="back-container__cta-title">가까운 매장 찾기</div>
          <div class="back-container__cta-sub-title">우리 동네 가까운 매장 찾아보기</div>
        </div>
        </router-link>
        <div class="main-container" :style="mainContainerStyle">
          <Header></Header>
          <router-view></router-view>
          <Footer></Footer>
        </div>
      </div>
    </div>
    <scroll-animation></scroll-animation>
    <HearingAlert />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import MainHeader from "./components/MainHeader.vue";
import MainFooter from "./components/MainFooter.vue";
import ScrollAnimation from "./components/ScrollAnimation.vue";
import MobileMainHeader from "./components/mobile/MMainHeader.vue";
import MobileMainFooter from "./components/mobile/MMainFooter.vue";
import TopButton from "./components/TopButton.vue";
import MobileTopButton from "./components/mobile/MTopButton.vue";
import HearingAlert from "./components/HearingAlert.vue";
import '@/assets/scss/main.scss';

import dotenv from "dotenv";
// import Footer from "@/components/Footer.vue";

export default {
  name: "App",

  data() {
    return {
      isMobileIndex: false,
      ctaAreaHeight: 0,
    };
  },
  components: {
    Footer,
    // HelloWorld
    Header,
    MainHeader,
    MainFooter,
    ScrollAnimation,
    MobileMainHeader,
    MobileMainFooter,
    TopButton,
    MobileTopButton,
    HearingAlert,
  },
  created() {
    dotenv.config();
    if (process.env.NODE_ENV == "development") {
      console.log("개발서버입니다");
    } else if (process.env.NODE_ENV == "production") {
      console.log("Welcome Davich Homepage");
    }

    const self = this;

    function detectMobileDevice(agent) {
      const mobileRegex = [
        /Android/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
      ];

      return mobileRegex.some((mobile) => agent.match(mobile));
    }

    const isMobile = detectMobileDevice(window.navigator.userAgent);

    if (isMobile) {
      self.isMobileIndex = true;
    } else {
      self.isMobileIndex = false;
    }

    this.$store.dispatch("FETCH_POPUP");
    this.$store.dispatch("FETCH_MAIN_VIDEO");
    this.$store.dispatch("FETCH_COUNT");
    this.$store.dispatch("FETCH_INSTA");
    this.$store.dispatch("FETCH_HISTORY");

    //products
    this.$store.dispatch("products/FETCH_GLASSES_FRAME");
    this.$store.dispatch("products/FETCH_GLASSES_LENS");
    this.$store.dispatch("products/FETCH_CONTACT_LENS");
    this.$store.dispatch("products/FETCH_HEARING_AID");

    this.$store.dispatch("support/FETCH_STORE");

    //가맹점현황 데이터
    this.$store.dispatch("partnership/FETCH_OPENED");
    //광고홍보영상 데이터
    this.$store.dispatch("whatsnew/FETCH_CF");

    this.$store.dispatch("others/FETCH_PRIVACY");
  },
  mounted() {
    this.updateCtaAreaHeight();
    window.addEventListener('resize', this.updateCtaAreaHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateCtaAreaHeight);
  },
  computed: {
    goToTopBottom() {
      if (this.$route.name === 'index' && this.ctaAreaHeight > 0) {
        return `${this.ctaAreaHeight + 20}px`;
      }
      return '20px';
    },
    mainContainerStyle() {
      if (this.$route.name === 'index' && this.ctaAreaHeight > 0) {
        return { paddingBottom: `${this.ctaAreaHeight}px` };
      }
      return {};
    }
  },
  watch: {
    $route() {
      this.updateCtaAreaHeight();
    }
  },
  methods: {
    updateCtaAreaHeight() {
      this.$nextTick(() => {
        const ctaArea = document.querySelector('.main-area-1__cta-area');
        if (ctaArea) {
          this.ctaAreaHeight = ctaArea.offsetHeight;
        } else {
          this.ctaAreaHeight = 0;
        }
      });
    },
    goToTop(){
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth' // 부드러운 스크롤
      });
    },
    // 떠 있는 "간편 상담신청" 버튼: 매장 고르는 화면이 열려 있어도 항상 간편 상담 신청 화면이 되도록
    // 같은 페이지면 링크 이동이 일어나지 않으므로 여기서 매장 화면만 닫는다
    onConsultationCta() {
      const navigating = this.$route.path !== '/customer/consultation';
      window.dispatchEvent(new CustomEvent('store-picker:close', { detail: { navigating } }));
    }
  },
};
</script>

<style lang="scss">
$main-w: 500px;
$goToTop-offset: 20px;

#goToTop{
  z-index: 1199;
  position: fixed;
  right: calc(50% - min($main-w, 100vw) / 2 + $goToTop-offset);
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  //background: rgba(255, 255, 255, 0.2);
  //background: rgba(38, 47, 66, 0.9);
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid #fff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  //transition: all 0.3s ease;
  backdrop-filter: blur(5px);
}
.arrow-down{
  width: 15px;
  height: 15px;
  border-bottom: 1px solid #fff;
  border-right: 1px solid #fff;
  transform: rotate(225deg);
  margin-bottom: -5px;
}
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
